import { ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCart } from "@/hooks/useCart";

const CartIcon = () => {
  const { itemCount, setDrawerOpen } = useCart();

  return (
    <Button
      variant="ghost"
      size="sm"
      className="relative"
      onClick={() => setDrawerOpen(true)}
      aria-label={`Shopping cart with ${itemCount} items`}
    >
      <ShoppingCart className="w-5 h-5" />
      {itemCount > 0 && (
        <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-primary text-primary-foreground text-xs font-bold flex items-center justify-center">
          {itemCount > 9 ? "9+" : itemCount}
        </span>
      )}
    </Button>
  );
};

export default CartIcon;
